import { Checkbox, Flex, NumberInput, SimpleGrid, TextInput } from '@mantine/core';
import { EmailServerIntegrationType, IMailServer } from '@/services/api/emailServerApiArea/types';
import React from 'react';
import { useMediaQuery } from '@mantine/hooks';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { ConnectionsSelect } from '@/containers/pages/filials/edit/components/tabs/mail-servers/components/connection-select';
import AuthTypeSelect from '@/containers/pages/filials/edit/components/tabs/mail-servers/components/auth-type';
import { useStyles } from '../../../../styles';

interface Props {
  form: UseFormReturnType<IMailServer>;
  isOnIntegration: boolean;
  integrationType?: EmailServerIntegrationType;
  toggleIntegration(): void;
}

const MainForm = (props: Props) => {
  const { form, isOnIntegration, integrationType, toggleIntegration } = props;
  const isMobile = useMediaQuery('(max-width: 992px)');
  const { t } = useTranslation();
  const { classes } = useStyles();

  const isApiIntegration = integrationType === EmailServerIntegrationType.Api;

  return (
    <>
      <SimpleGrid cols={isMobile ? 1 : 2} w="100%">
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.name')}
          label={t('servers.nameLabel')}
          withAsterisk
          {...form.getInputProps('Name')}
        />
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.domains')}
          label={t('servers.domainsLabel')}
          withAsterisk={!isApiIntegration}
          disabled={isApiIntegration}
          {...form.getInputProps('Domains')}
        />
      </SimpleGrid>
      <SimpleGrid cols={isMobile ? 1 : 2} mt={16} w="100%">
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.popServer')}
          label={t('servers.popServer')}
          withAsterisk
          {...form.getInputProps('PopServer')}
        />
        <Flex
          className={classes.rightSideContainerTwoItems}
          gap="24px"
          direction={isMobile ? 'column' : 'row'}
        >
          <NumberInput
            className={classes.textFieldInput}
            autoComplete="off"
            maw={isMobile ? 'auto' : 70}
            placeholder={t('servers.port')}
            label={t('servers.port')}
            withAsterisk
            hideControls
            defaultValue=""
            mb={isMobile ? '20px' : ''}
            {...form.getInputProps('PopPort')}
          />
          <ConnectionsSelect
            placeholder={t('servers.connection')}
            form={form}
            fieldName="PopConnectionType"
            label={t('servers.connectionType')}
            value={form.getInputProps('PopConnectionType').value}
          />
        </Flex>
      </SimpleGrid>
      <SimpleGrid cols={isMobile ? 1 : 2} mt={16} w="100%">
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.imapServer')}
          label={t('servers.imapServer')}
          withAsterisk
          {...form.getInputProps('ImapServer')}
        />
        <Flex
          className={classes.rightSideContainer}
          gap="24px"
          direction={isMobile ? 'column' : 'row'}
        >
          <NumberInput
            className={classes.textFieldInput}
            autoComplete="off"
            maw={isMobile ? 'auto' : 70}
            placeholder={t('servers.port')}
            label={t('servers.port')}
            withAsterisk
            hideControls
            defaultValue=""
            mb={isMobile ? '20px' : ''}
            {...form.getInputProps('ImapPort')}
          />
          <ConnectionsSelect
            placeholder={t('servers.connection')}
            form={form}
            fieldName="ImapConnectionType"
            label={t('servers.connectionType')}
            value={form.getInputProps('ImapConnectionType').value}
          />
          <AuthTypeSelect
            form={form}
            placeholder={t('servers.authType')}
            fieldName="ImapLoginType"
            label={t('servers.authType')}
            value={form.getInputProps('ImapLoginType').value}
          />
        </Flex>
      </SimpleGrid>
      <SimpleGrid cols={isMobile ? 1 : 2} mt={16} w="100%">
        <TextInput
          className={classes.textFieldInput}
          placeholder={t('servers.smtpServer')}
          label={t('servers.smtpServer')}
          withAsterisk
          {...form.getInputProps('SmtpServer')}
        />
        <Flex
          className={classes.rightSideContainer}
          gap="24px"
          direction={isMobile ? 'column' : 'row'}
        >
          <NumberInput
            className={classes.textFieldInput}
            autoComplete="off"
            maw={isMobile ? 'auto' : 70}
            placeholder={t('servers.port')}
            label={t('servers.port')}
            withAsterisk
            hideControls
            defaultValue=""
            mb={isMobile ? '20px' : ''}
            {...form.getInputProps('SmtpPort')}
          />
          <ConnectionsSelect
            placeholder={t('servers.connection')}
            form={form}
            fieldName="SmtpConnectionType"
            label={t('servers.connectionType')}
            value={form.getInputProps('SmtpConnectionType').value}
          />
          <AuthTypeSelect
            form={form}
            placeholder={t('servers.authType')}
            fieldName="SmtpLoginType"
            label={t('servers.authType')}
            value={form.getInputProps('SmtpLoginType').value}
          />
        </Flex>
      </SimpleGrid>
      <SimpleGrid cols={isMobile ? 1 : 2} mt={16} w="100%">
        <Checkbox
          className={classes.checkbox}
          label={t('servers.turnOnConnection')}
          size="xs"
          checked={isOnIntegration}
          onChange={toggleIntegration}
        />
      </SimpleGrid>
    </>
  );
};

export default MainForm;
